import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// GTM y CookieYes los carga `window.__mtsCargarConsentimiento`, definida en
// index.html (lo antes posible, con un guard que excluye /redirect, /en1 y las
// legales). Este componente cubre la navegación SPA en los dos sentidos:
//
// - HACIA una ruta excluida con el script YA cargado (p.ej. de /login a /terms):
//   oculta su UI por CSS mientras esté en ella.
// - DESDE una ruta excluida hacia una que no lo es (escanear un QR sin
//   configurar → /redirect → «CREAR MI CUENTA» → /register): vuelve a llamar al
//   loader, que en la carga dura no hizo nada. Sin esto el banner no salía hasta
//   la siguiente carga dura —la vuelta del OAuth de Google, en mitad del
//   onboarding— y el `sign_up` no llegaba a GA4. Ver decisiones §163.
//
// Mantén esta lista en sincronía con el guard de index.html, que es el mismo
// para CookieYes y para Google Tag Manager.
const IDIOMAS = ['es', 'en', 'pt', 'de', 'fr'];

export function isExcludedPath(pathname) {
  const p = pathname.toLowerCase().replace(/\/+$/, '');
  // El prefijo de idioma se despega antes de comparar, como en index.html: si
  // no, /de/terms no contaría como legal. `/en1/<id>` no es `/en` + algo.
  const prefijo = IDIOMAS.find((l) => p === `/${l}` || p.startsWith(`/${l}/`));
  const sinPrefijo = prefijo ? p.slice(prefijo.length + 1) || '/' : p;
  if (sinPrefijo === '/redirect') return true;
  if (sinPrefijo.startsWith('/en1/')) return true;
  return ['/terms', '/privacy', '/dpa', '/legal-notice', '/cookies'].includes(sinPrefijo);
}

export default function CookieConsent() {
  const { pathname } = useLocation();

  useEffect(() => {
    const excluida = isExcludedPath(pathname);
    // OJO: la clase NO puede empezar por `cky-` ni llamarse `cky-hide`: el propio
    // CSS de CookieYes define `.cky-hide { display: none !important }` como
    // utilidad interna. Si marcáramos <html> con `cky-hide`, en cuanto el script
    // de CookieYes está cargado (staging/prod, al navegar por SPA a una legal)
    // ese `.cky-hide` esconde el <html> entero → página en blanco. Usamos una
    // clase propia fuera de su namespace.
    document.documentElement.classList.toggle('hide-cky-ui', excluida);
    // El loader se protege solo (ruta excluida o ya cargado → no hace nada) y
    // no existe sin index.html (tests): de ahí el `?.`.
    if (!excluida) window.__mtsCargarConsentimiento?.();
  }, [pathname]);

  // Oculta toda la UI de CookieYes (banner, modal de preferencias, overlay y el
  // botón flotante de "revisar consentimiento") mientras <html> tenga `hide-cky-ui`.
  return (
    <style>{`
      html.hide-cky-ui .cky-consent-container,
      html.hide-cky-ui .cky-consent-bar,
      html.hide-cky-ui .cky-modal,
      html.hide-cky-ui .cky-overlay,
      html.hide-cky-ui .cky-btn-revisit-wrapper { display: none !important; }
    `}</style>
  );
}
